// Full searchable radio details from the supplied 2023 statewide channel plan.
export default String.raw`24.1|151.1600|136.5|159.2700|OST|H|N|CDF SHU LOCAL NET
24.2|154.4300|136.5|159.0150|OST|H|N|Shasta Co. Command
24.3|154.0100|000.0|154.0100|000.0|L|N|Shasta Co. TAC
24.4|153.9500|000.0|153.9500|000.0|L|N|Shasta Co. TAC
24.5|154.2650|156.7|154.2650|156.7|L|N|
24.6|154.2950|156.7|154.2950|156.7|L|N|
24.7|154.2725|156.7|154.2725|156.7|L|N|
24.8|154.2875|156.7|154.2875|156.7|L|N|
24.9|154.3025|156.7|154.3025|156.7|L|N|
24.10|155.3400|000.0|155.3400|000.0|H|N|
24.11|151.2200|192.8|151.2200|192.8|L|N|
24.12|159.2625|192.8|159.2625|192.8|L|N|
24.13|159.3675|192.8|159.3675|192.8|L|N|
24.14|151.2575|192.8|151.2575|192.8|L|N|
24.15|151.3850|192.8|151.3850|192.8|L|N|
24.16|151.4450|192.8|151.4450|192.8|L|N|
24.17|151.4600|192.8|151.4600|192.8|L|N|
24.18|151.3550|103.5|159.3000|OST|H|N|
24.19|151.2650|103.5|159.3300|OST|H|N|
24.20|151.1750|103.5|159.4500|OST|H|N|CDF CMD 9
24.21|156.0750|156.7|156.0750|156.7|H|N|
24.22|154.0000|000.0|154.0000|000.0|H|N|Added (x-patched) Dispatch Only
24.23|154.3250|000.0|153.7700|OST|H|N|Renamed (x-patch to 800Mhz sys)
24.24|158.8050|000.0|155.8050|OST|H|N|Added (x-patch to 800Mhz sys)
24.25|154.2050|000.0|154.2050|000.0|L|N|No x-patch /VHF backup only
24.26|154.2350|000.0|154.2350|000.0|L|N|No x-patch /VHF backup only
24.27|154.2500|000.0|154.2500|000.0|L|N|No x-patch /VHF backup only
24.28|154.3550|000.0|154.3550|000.0|L|N|No x-patch /VHF backup only
24.29|154.1300|000.0|154.1300|000.0|L|N|
24.30|154.3100|192.8|154.3100|192.8|L|N|
24.31|154.0550|000.0|154.0550|000.0|L|N|
24.32|154.1750|000.0|154.1750|000.0|L|N|
24.33|154.1900|000.0|154.1900|000.0|L|N|
24.34|153.9650|192.8|153.9650|192.8|L|N|Shasta Fire Protection Dist. Net
24.35|173.1875|000.0|164.8000|000.0|H|N|
24.36|171.4750|000.0|164.9125|000.0|H|N|
24.37|168.6625|000.0|168.6625|000.0|H|N|
24.38|172.4625|110.9|165.6000|110.9|H|N|
24.39|172.4375|110.9|166.3375|110.9|H|N|
24.40|169.8125|110.9|163.0250|110.9|H|N|
24.41|169.7875|110.9|164.1625|110.9|H|N|
24.42|163.7125|000.0|163.7125|000.0|H|N|
24.43|154.7850|114.8|158.7600|000.0|H|N|
24.44|154.4150|000.0|158.9250|000.0|H|N|
24.45|155.1150|000.0|155.9250|000.0|H|N|
24.46|154.3700|000.0|154.3700|000.0|H|N|
24.47|154.3400|000.0|154.3400|000.0|H|N|
24.48|154.4450|000.0|154.4450|000.0|L|N|
24.49|155.0850|000.0|155.0850|000.0|L|N|
24.50|154.4300|000.0|154.4300|000.0|L|N|
24.51|171.5750|000.0|165.0125|000.0|H|N|
24.52|171.5000|000.0|164.8250|000.0|H|N|
24.53|167.2250|000.0|167.2250|000.0|H|N|
24.54|168.9625|000.0|168.9625|000.0|H|N|
24.55|167.7250|000.0|167.7250|000.0|H|N|
24.56|166.9875|000.0|166.9875|000.0|H|N|
24.57|168.2000|000.0|168.2000|000.0|L|N|
24.58|166.5500|000.0|166.5500|000.0|L|N|USFS RGN 5 TAC 4
24.59|167.1125|000.0|167.1125|000.0|L|N|USFS RGN 5 TAC 5
24.60|168.2375|000.0|168.2375|000.0|L|N|USFS RGN 5 TAC 6
24.61|167.6000|000.0|167.6000|000.0|L|N|
24.62|166.8750|000.0|166.8750|000.0|L|N|
24.63|172.4750|131.8|166.2750|131.8|H|N|P25 Whiskeytown Rec Area
24.64|168.6125|000.0|168.6125|000.0|L|N|Whis. Recreational Unit TAC
24.65|155.1600|000.0|155.1600|000.0|H|N|Multi agency Ops
24.66|155.0700|000.0|155.0700|000.0|H|N|Rx & Tx LE needed - all loads
24.67|158.7300|000.0|0.0000|000.0||N|RX ONLY for non-LE load
24.68|155.6100|000.0|0.0000|000.0||N|RX ONLY for non-LE load
24.69|159.0900|000.0|0.0000|000.0||N|RX ONLY for non-LE load
24.70|154.8600|218.1|0.0000|000.0||N|RX ONLY for non-LE load
24.71|154.7400|74.4|0.0000|000.0||N|RX ONLY for non-LE load
24.72|155.6850|141.3|0.0000|000.0||N|RX ONLY for non-LE load
24.73|154.9200|156.7|0.0000|000.0||N|RX ONLY for non-LE load
24.74|154.9350|156.7|0.0000|000.0||N|RX ONLY for non-LE load
24.75|168.6250|000.0|168.6250|110.9|L|N|Emergency
25.1|151.37000|146.2|159.28500|000.0|H|N|
25.2|154.38500|136.5|154.38500|136.5|H|N|
25.3|156.07500|156.7|156.07500|156.7|H|N|
25.4|151.2575|192.8|151.2575|192.8|L|N|
25.5|151.17500|192.8|151.17500|192.8|L|N|
25.6|151.19000|192.8|151.19000|192.8|L|N|
25.7|151.38500|192.8|151.38500|192.8|L|N|
25.8|151.44500|192.8|151.44500|192.8|L|N|
25.9|151.46000|192.8|151.46000|192.8|L|N|
25.10|154.28000|156.7|154.28000|156.7|H|N|
25.11|154.26500|156.7|154.26500|156.7|L|N|
25.12|154.29500|156.7|154.29500|156.7|L|N|
25.13|151.22000|192.8|151.22000|192.8|L|N|
25.14|159.26250|192.8|159.26250|192.8|L|N|
25.15|159.36750|192.8|159.36750|192.8|L|N|
25.16|151.35500|103.5|159.30000|000.0|H|N|
25.17|151.26500|103.5|159.33000|000.0|H|N|
25.18|151.46000|103.5|159.39000|000.0|H|N|
25.19|151.17500|103.5|159.45000|000.0|H|N|
25.20|154.14500|107.2|159.04500|107.2|H|N|
25.21|153.83000|000.0|153.83000|156.7|L|N|
25.22|154.20500|000.0|154.20500|156.7|L|N|
25.23|154.40000|000.0|154.40000|131.8|L|N|
25.24|154.40000|000.0|158.83500|000.0|H|N|
25.25|154.40000|000.0|154.40000|100.0|L|N|
25.26|154.34000|000.0|153.89000|100.0|H|N|
25.27|156.18000|000.0|159.01500|127.3|H|N|
25.28|154.31000|192.8|154.31000|192.8|L|N|
25.29|154.32500|91.5|153.77000|91.5|H|N|
25.30|154.19000|110.9|153.77000|110.9|H|N|
25.31|154.22000|000.0|159.19500|000.0|H|N|
25.32|172.46250|110.9|165.60000|110.9|H|N|
25.33|169.78750|110.9|164.16250|110.9|H|N|
25.34|172.43750|110.9|166.33750|110.9|H|N|
25.35|169.81250|110.9|163.02500|110.9|H|N|
25.36|163.71250|000.0|163.71250|000.0|H|N|
25.37|173.18750|000.0|164.80000|000.0|H|N|
25.38|171.47500|000.0|164.91250|000.0|H|N|
25.39|169.95000|000.0|164.10000|000.0|H|N|
25.40|171.57500|000.0|165.01250|000.0|H|N|
25.41|171.50000|000.0|164.82500|000.0|H|N|
25.42|169.97500|000.0|169.17500|000.0|H|N|
25.43|171.55000|000.0|164.50000|000.0|H|N|
25.44|172.40000|000.0|164.12500|000.0|H|N|
25.45|151.40000|110.9|159.37500|000.0|H|N|
25.46|151.25000|123.0|159.40500|000.0|H|N|
25.47|151.16000|136.5|159.27000|000.0|H|N|
25.48|162.55000|000.0|000.00000|000.0||W|
25.49|162.40000|000.0|000.00000|000.0||W|
25.50|153.75500|000.0|154.98000|000.0|H|N|
25.51|154.74000|74.4|000.00000|000.0||N|
25.52|154.02500|100.0|000.00000|000.0||N|
25.53|153.83000|000.0|000.00000|000.0||N|
25.54|155.68500|141.3|000.00000|000.0||N|
25.55|155.79000|123.0|000.00000|000.0||N|
25.56|155.55000|123.0|000.00000|000.0||N|
25.57|155.19000|100.0|000.00000|000.0||N|
25.58|168.62500|000.0|168.62500|110.9|L|N|Emergency
26.1|151.32500|156.7|159.36000|000.0|H|N|CDF SKU Local
26.2|151.35500|103.5|159.30000|000.0|H|N|CDF Command 1
26.3|151.26500|103.5|159.33000|000.0|H|N|CDF Command 2
26.4|151.19000|103.5|159.22500|000.0|H|N|CDF Command 10
26.5|151.22000|192.8|151.22000|192.8|L|N|CDF Air to Ground 1
26.6|159.26250|192.8|159.26250|192.8|L|N|CDF Air to Ground 2
26.7|151.25750|192.8|151.25750|192.8|L|N|CDF Tac 1
26.8|151.34000|192.8|151.34000|192.8|L|N|CDF Tac 7
26.9|151.37000|192.8|151.37000|192.8|L|N|CDF Tac 8
26.10|151.38500|192.8|151.38500|192.8|L|N|CDF Tac 9
26.11|151.40000|192.8|151.40000|192.8|L|N|CDF Tac 10
26.12|151.44500|192.8|151.44500|192.8|L|N|CDF Tac 11
26.13|151.46000|192.8|151.46000|192.8|L|N|CDF Tac 12
26.14|153.75500|000.0|153.75500|000.0|H|N|CESRS DIRECT SIMPLEX
26.15|151.16000|136.5|159.27000|000.0|H|N|CDF SHU Local
26.16|154.43000|136.5|159.01500|000.0|H|N|CDF Shasta Co. Command
26.17|151.25000|123.0|159.40500|000.0|H|N|CDF LMU LOCAL NET
26.18|154.23500|192.8|154.23500|192.8|L|N|Hilt Colstin Fire
26.19|155.89500|000.0|155.89500|000.0|L|N|McCloud Fire
26.20|154.04000|000.0|158.74500|000.0|H|N|South County Fire Admin net
26.21|154.25000|000.0|156.10500|000.0|H|N|Siskiyou County Command
26.22|154.34000|000.0|154.34000|000.0|L|N|Siskiyou County Tac
26.23|154.28000|156.7|154.28000|156.7|H|N|VFIRE 21
26.24|154.26500|156.7|154.26500|156.7|L|N|VFIRE 22
26.25|154.29500|156.7|154.29500|156.7|L|N|VFIRE 23
26.26|154.27250|156.7|154.27250|156.7|L|N|VFIRE 24
26.27|154.28750|156.7|154.28750|156.7|L|N|VFIRE 25
26.28|154.30250|156.7|154.30250|156.7|L|N|VFIRE 26
26.29|156.07500|156.7|156.07500|156.7|H|N|Calcord
26.30|154.43000|000.0|159.19000|110.9|H|N|Yreka City Fire
26.31|169.63750|000.0|168.77500|000.0|H|N|USFS KNF Black / Oak Knoll
26.32|172.27500|000.0|164.70000|000.0|H|N|KNF Orange / Happy Cmp
26.33|172.40000|000.0|164.12500|000.0|H|N|KNF Salmon / Salmon Riv
26.34|172.25000|000.0|165.07500|000.0|H|N|USFS KNF River / Scott Riv
26.35|172.32500|000.0|162.22500|000.0|H|N|USFS KNF Sage / Goosenest
26.36|167.60000|000.0|167.60000|000.0|L|N|IA Air/Ground Primary CAO1
26.37|166.87500|000.0|166.87500|000.0|L|N|IA Air/Gnd Secondary CAO1
26.38|168.05000|000.0|168.05000|000.0|L|N|NIFC TAC 1
26.39|168.20000|000.0|168.20000|000.0|L|N|NIFC TAC 2
26.40|168.60000|000.0|168.60000|000.0|L|N|NIFC TAC 3
26.41|166.55000|000.0|166.55000|000.0|L|N|USFS RGN 5 TAC 4
26.42|171.57500|000.0|165.01250|000.0|H|N|SHF Forest Net
26.43|168.96250|000.0|168.96250|000.0|H|N|USFS SHF Trinity River MU
26.44|166.98750|000.0|166.98750|000.0|H|N|SHF Shsta McCloud Unit
26.45|171.52500|000.0|165.41250|000.0|H|N|USFS KNF Forest Net
26.46|172.37500|000.0|164.17500|000.0|H|N|USFS Six Rivers NF
26.47|170.47500|000.0|165.75000|000.0|H|N|USFS Six Rivers Admin Net
26.48|173.18750|000.0|164.80000|000.0|H|N|USFS Lassen NF
26.49|170.73750|000.0|164.98750|000.0|H|N|USFS Modoc NF
26.50|151.20500|131.8|159.37500|000.0|H|N|ODF Klamath Lake District
26.51|151.17500|179.9|159.41250|000.0|H|N|ODF Medford District
26.52|151.34000|000.0|151.34000|156.7|L|N|ODF Red Net
26.53|156.02250|156.7|156.02250|156.7|L|N|ODF ORANGE AIR/GROUND
26.54|151.31000|000.0|151.31000|156.7|L|N|ODF White Net Air/Ground
26.55|159.26250|000.0|159.26250|156.7|H|N|ODF Blue Net
26.56|154.28000|000.0|154.28000|000.0|L|N|RV Tac 1 / ODF NICS
26.57|159.24000|000.0|159.24000|156.7|L|N|RV Tac 2 / ODF NICS
26.58|153.83000|000.0|153.83000|000.0|L|N|RV Tac 3 / ODF NICS
26.59|154.31000|000.0|153.89000|000.0|H|N|OR SO CO FIRE T-5-10-13
26.60|158.77500|000.0|153.78500|000.0|H|N|Ashland Fire Rescue Local
26.61|154.17500|000.0|154.17500|136.5|H|N|Ashland Fire Rescue Ops1
26.62|154.07000|000.0|154.40000|107.2|H|N|Klamath Co Fire Com Ham
26.63|155.82000|000.0|155.82000|000.0|L|N|Klamath Co Fire Tac 3
26.64|153.89000|000.0|153.89000|000.0|L|N|Klamath Co Fire Tac 4
26.65|170.55000|000.0|164.87500|000.0|H|N|PLUMAS NF FOREST REP. NET
26.66|170.60000|000.0|164.93750|000.0|H|N|TAHOE NF FIRE REP. NET Fall 2018
26.67|169.90000|000.0|168.77500|000.0|H|N|TAHOE NF FIRE REP. NET Fall 2018
26.68|171.55000|000.0|164.50000|000.0|H|N|MENDOCINO FIRE REP. NET
26.69|155.31000|123.0|000.00000|000.0||N|Siskiyou SO - Receive Only
26.70|155.41500|110.9|000.00000|000.0||N|RX ONLY for non-LE load
26.71|154.74000|156.7|000.00000|000.0||N|RX ONLY for non-LE load
26.72|155.01000|000.0|000.00000|000.0||N|RX ONLY for non-LE load
26.73|155.61000|131.8|000.00000|000.0||N|RX ONLY for non-LE load
26.74|155.53500|127.3|000.00000|000.0||N|RX ONLY for non-LE load
26.75|155.11500|000.0|000.00000|000.0||N|RX ONLY for non-LE load
26.76|154.74000|000.0|000.00000|000.0||N|RX ONLY for non-LE load
26.77|153.98000|000.0|000.00000|000.0||N|RX ONLY for non-LE load
26.78|158.88000|123.0|000.00000|000.0||N|RX ONLY for non-LE load
26.79|153.75500|000.0|154.98000|000.0|H|N|Travel Net
26.80|168.62500|000.0|168.62500|110.9|L|N|Emergency`;
